export const CHART_TICK_STYLE = {
  fontSize: 10,
  fill: '#6c7086',
  fontFamily: 'IBM Plex Mono, monospace',
} as const

export const CHART_TICK_STYLE_LIGHT = {
  fontSize: 10,
  fill: '#a6adc8',
  fontFamily: 'IBM Plex Mono, monospace',
} as const
